import { ThemingConfig, Token, Tokens } from '@chakra-ui/react';
import { isFunction, kebabCase } from 'lodash';
import { Theme } from './theme';
type TokenCategory = keyof NonNullable<ThemingConfig['tokens']>;
type Config<T extends TokenCategory = TokenCategory> = {
  scale: T;
  property?: string;
  properties?: string[];
  base?: Tokens[T];
};

export const system = (config: Record<string, Config>) => (props: { theme: Theme } & { [key: string]: any }) =>
  Object.entries(config)
    .map(([key, { property, properties, scale, base }]) => {
      const prop = props[key] ?? base;

      if (!prop) return;

      const path = `${scale}.${prop}` as Token;
      const cssProperties = [property, ...(properties || [])].filter((p) => !!p).map((p) => kebabCase(p));

      return cssProperties.map((cssProperty) => `${cssProperty}: ${props.theme.token(path) ?? prop};`).join('\n');
    })
    .join('\n');

export const compose =
  (...fns: ((props: any) => string)[]) =>
  (props: { theme: any; [key: string]: any }) =>
    fns.map((fn) => fn(props)).join('\n');

export const variant =
  ({ prop = 'variant', variants = {} }: any) =>
  (props: { theme: any; [key: string]: any }) => {
    const variant = variants[props[prop]];
    const themedVariant = isFunction(variant) ? variant(props.theme) : variant;

    return Object.fromEntries(
      Object.entries(themedVariant).map(([key, value]) => {
        if (isFunction(value)) {
          return [key, value(props.theme)];
        } else {
          return [key, value];
        }
      }),
    );
  };
